import classes from "../classes";
import EntrantPicksPopup from "./entrant-picks-popup";
import { List } from "immutable";
import PlayerPicks from "./player-picks";
import PlayFieldRaceEntrantPick from "./play-field-race-entrant-pick";
import pure from "./higher-order/pure";
import React from "react";
import selectPage from "../select-page";

export default pure(function PlayFieldRaceEntrant({ bets, myTickets, onMakeAlternatePick, onMakePick, page, pageSize, pendingPicks, race, raceEntrant, raceEntrants, savedPicks, tickets, tournament, users }) {
  var picks;
  var betsForRace = bets.get(race.get("id"));
  if (betsForRace && race.get("status") !== "open") {

    var betIdsForEntrant = tournament.getIn(["picks", raceEntrant.get("id").toString()]) || List();
    var betsForEntrant = betIdsForEntrant.map(betId => betsForRace.get(betId)).filter(bet => bet);
    var ticketsForBets = betsForEntrant
      .map((bet) => tickets.find((t) => t && bet && t.get("id") === bet.get("ticket_id")))
      .filter(t => t)
      .sort((a, b) => a.get("rank") - b.get("rank"));

    var picksForRace = race
      .get("race_entrants")
      .map(entrantId => (tournament.getIn(["picks", entrantId.toString()]) || List()).count())
      .reduce((a, b) => Math.max(a, b));

    picks = (
      <EntrantPicksPopup raceEntrant={raceEntrant} tickets={ticketsForBets} users={users}>
        <PlayerPicks maxPicks={picksForRace} number={ticketsForBets.count()} />
      </EntrantPicksPopup>
    );
  }

  if (raceEntrant.get("scratched")) {
    picks = (
      <span className="game-table_status game-table_status--scratched">
        -- Scratched --
      </span>
    );
  }

  var disablePicks = raceEntrant.get("scratched") || race.get("status") !== "open" || (tournament.get("status") !== "open" && tournament.get("lockdown"));

  var prevPage = null;
  var nextPage = null;
  if (myTickets.size > pageSize) {
    prevPage = (
      <div className="game-table_cell game-table_cell--nav" />
    );
    nextPage = (
      <div className="game-table_cell game-table_cell--nav" />
    );
  }

  return (
    <div className={classes({
      "game-table_row": true,
      "game-table_row--horses": true,
      ["game-table_row--horses-" + raceEntrant.get("lane_number")]: true,
      "game-table_row--scratched": raceEntrant.get("scratched"),
      "game-table_row--is-saved": tickets.find(ticket => savedPicks.get(ticket.get("id")) === raceEntrant.get("id"))
    })}>
      <div className="game-table_cell game-table_cell--horse-name">
        <ul className="game-table_horse">
          <li>
            {raceEntrant.get("horse_name")}
          </li>

          <li />
        </ul>
      </div>

      <div className="game-table_cell game-table_cell--horse-odds">
        {raceEntrant.get("morning_line")}
      </div>

      <div className="game-table_cell game-table_cell--horse-jockey">
        {raceEntrant.get("jockey_name")}
      </div>

      <div className="game-table_cell game-table_cell--horse-trainer">
        {raceEntrant.get("trainer_name")}
      </div>

      <div className="game-table_cell game-table_cell--player-picks">
        {picks}
      </div>

      {prevPage}

      {selectPage(myTickets, page, pageSize).map((ticket) => (
        <PlayFieldRaceEntrantPick
          bets={bets}
          disabled={disablePicks}
          key={ticket.get("id")}
          onMakeAlternatePick={onMakeAlternatePick}
          onMakePick={onMakePick}
          pendingPicks={pendingPicks}
          race={race}
          raceEntrant={raceEntrant}
          raceEntrants={raceEntrants}
          savedPicks={savedPicks}
          ticket={ticket}
          tournament={tournament} />)
      )}

      {nextPage}
    </div>
  );
});
